import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from 'src/ui/layout';
import AppUpdateLandingContainer from 'src/ui/features/AppUpdate/containers/AppUpdateLandingContainer';
import { updateBodyClass } from 'src/helpers';
import { APP_UPDATE_URL, BODY_CLASSES } from 'src/constants/constants.js';
import withRouter from 'src/utils/withRouter';

const AppUpdateLandingContainerWithRouter = withRouter(AppUpdateLandingContainer);

class AppUpdateRoot extends React.Component {
  componentDidMount() {
    updateBodyClass(BODY_CLASSES.UPDATE_APP);
  }

  componentWillUnmount() {
    updateBodyClass(BODY_CLASSES.UPDATE_APP);
  }

  render() {
    return (
      <Layout headerName={'App Version Update Management'}>
        <Routes>
          {/* <Route path={CASES_URL + '/detail/:caseManagerId'} render={props => <CasesDetailContainer {...props} />} />
          <Route path={CASES_URL + '/team/detail/:caseManagerId'} render={props => <CasesDetailContainer teamCases={true} {...props} />} />
          <Route path={CASES_URL + '/team'} render={props => <CasesLandingContainer key={'teamCases'} teamCases={true} {...props} />} /> */}
          <Route path={'*'} element={<AppUpdateLandingContainerWithRouter />} />
        </Routes>
      </Layout>
    );
  }
}

export default AppUpdateRoot;
